/** Pauses after a deploy-time failure: 1s, then 3s. */
export const TRANSIENT_RETRY_MS = [1000, 3000];

/**
 * Run `work` again when the server is briefly away: a network error (no
 * status) or a 502/503/504. Any other failure stops immediately.
 */
export async function retryTransient(work, {
  delays = TRANSIENT_RETRY_MS,
  wait = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); }),
} = {}) {
  let attempt = 0;
  while (true) {
    try {
      return await work();
    } catch (err) {
      const raw = err?.status;
      const transient = raw == null || [502, 503, 504].includes(Number(raw));
      if (!transient || attempt >= delays.length) throw err;
      await wait(delays[attempt]);
      attempt += 1;
    }
  }
}
